import {PostStatusEnum} from '../../../../../service/posts/posts-types';

export const CANT_USE_POST_DETAILS_STATUSES: Array<PostStatusEnum> = [
    PostStatusEnum.Draft,
    PostStatusEnum.Planned,
    PostStatusEnum.Sending,
];
